// extracted by mini-css-extract-plugin
export default {"slideButtonComponent":"SlideButton_slideButtonComponent__oUZmY","button":"SlideButton_button__JFZYF","slideButtonContainer":"SlideButton_slideButtonContainer__VsaYw"};